"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumProxy__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
        ],
        name: "TransferWithReference",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "_to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_paymentReference",
                type: "bytes",
            },
        ],
        name: "transferWithReference",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class EthereumProxy__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.EthereumProxy__factory = EthereumProxy__factory;
EthereumProxy__factory.bytecode = _bytecode;
EthereumProxy__factory.abi = _abi;
